<script>
import Layout from "../../layouts/main";

export default {
  components: {
    Layout,
  },
};
</script>

<template>
  <Layout>
    <div class="my-5 pt-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center my-5">
              <h1 class="font-weight-bold text-error">
                4
                <span class="error-text">
                  0
                  <img src="@/assets/images/error-img.png" alt class="error-img" />
                </span> 4
              </h1>
              <h3 class="text-uppercase">Sorry, page not found</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>